var _path, _g, _g2, _path2, _g3, _g4, _g5, _g6, _rect, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInspire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 64,
    viewBox: "0 0 36 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.17863 16.457C3.15884 16.457 1.52148 18.0944 1.52148 20.1142V30.1713C1.52148 31.3749 2.10287 32.4426 3.00012 33.1091V41.0393C3.00012 43.0175 4.60379 44.6212 6.58202 44.6212H26.2825C28.2607 44.6212 29.8644 43.0175 29.8644 41.0393V32.5903C30.4334 31.9456 30.7786 31.0988 30.7786 30.1713V20.1142C30.7786 18.0944 29.1413 16.457 27.1215 16.457H5.17863Z",
    fill: "#E8D8FD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2021_276)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 52.1142C3 50.0944 4.63736 48.457 6.65714 48.457H26.7714C28.7912 48.457 30.4286 50.0944 30.4286 52.1142V60.3427C30.4286 62.3625 28.7912 63.9999 26.7714 63.9999H6.65714C4.63736 63.9999 3 62.3625 3 60.3427V52.1142Z",
    fill: "#B076F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.6855,
    y: 50.2856,
    width: 2.74286,
    height: 13.7143,
    fill: "#9F59F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 61.2568,
    width: 31.0857,
    height: 2.74286,
    fill: "#9F59F8"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2021_276)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 38.3999,
    width: 33.8286,
    height: 13.7143,
    rx: 3.65714,
    fill: "#B076F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.0859,
    y: 38.3999,
    width: 2.74286,
    height: 13.7143,
    fill: "#9F59F8"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 49.3711,
    width: 31.0857,
    height: 2.74286,
    fill: "#9F59F8"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.79072 24.115C2.67838 24.4745 1.74955 21.5682 2.04917 20.07L9.68958 15.5757H29.9142V21.4184V24.5644C25.4199 23.6655 20.0266 26.8116 19.1277 28.6093C18.4086 30.0475 17.33 29.2086 16.8806 28.6093C15.4424 24.6543 10.8881 23.9652 8.79072 24.115Z",
    fill: "#D2B1FC",
    stroke: "#D2B1FC",
    strokeWidth: 0.898873
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2021_276)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.52148,
    y: 5.48584,
    width: 7.31429,
    height: 18.2857,
    rx: 3.65714,
    fill: "#F7F0FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.46431 18.7428V6.3999H10.2072V26.5142H0.150028V22.857H3.35003C6.64146 22.857 7.46431 20.1142 7.46431 18.7428Z",
    fill: "#E8D8FD",
    stroke: "#E8D8FD",
    strokeWidth: 0.914286
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_2021_276)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.83594,
    y: 3.65723,
    width: 7.31429,
    height: 18.2857,
    rx: 3.65714,
    fill: "#F7F0FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7788 16.9141V4.57129H17.5216V24.6856H7.46448V21.0284H10.6645C13.9559 21.0284 14.7788 18.2856 14.7788 16.9141Z",
    fill: "#E8D8FD",
    stroke: "#E8D8FD",
    strokeWidth: 0.914286
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_2021_276)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.1504,
    y: 1.82861,
    width: 7.31429,
    height: 18.2857,
    rx: 3.65714,
    fill: "#F7F0FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0932 15.0855V2.74268H24.8361V22.857H14.7789V19.1998H17.9789C21.2704 19.1998 22.0932 16.457 22.0932 15.0855Z",
    fill: "#E8D8FD",
    stroke: "#E8D8FD",
    strokeWidth: 0.914286
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_2021_276)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.4639,
    width: 7.31429,
    height: 18.2857,
    rx: 3.65714,
    fill: "#F7F0FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4067 13.2569V0.914062H32.1496V21.0283H22.0924V17.3712H25.2924C28.5838 17.3712 29.4067 14.6283 29.4067 13.2569Z",
    fill: "#E8D8FD",
    stroke: "#E8D8FD",
    strokeWidth: 0.914286
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28.0352,
    y: 13.8003,
    width: 7.31429,
    height: 21.0286,
    rx: 3.65714,
    fill: "#E8D8FD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.8066,
    y: 14.6489,
    width: 7.31429,
    height: 14.2513,
    rx: 3.65714,
    transform: "rotate(-60 19.8066 14.6489)",
    fill: "#E8D8FD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2021_276"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 52.1142C3 50.0944 4.63736 48.457 6.65714 48.457H26.7714C28.7912 48.457 30.4286 50.0944 30.4286 52.1142V60.3427C30.4286 62.3625 28.7912 63.9999 26.7714 63.9999H6.65714C4.63736 63.9999 3 62.3625 3 60.3427V52.1142Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2021_276"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 38.3999,
    width: 33.8286,
    height: 13.7143,
    rx: 3.65714,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2021_276"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.52148,
    y: 5.48584,
    width: 7.31429,
    height: 18.2857,
    rx: 3.65714,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_2021_276"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.83594,
    y: 3.65723,
    width: 7.31429,
    height: 18.2857,
    rx: 3.65714,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_2021_276"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.1504,
    y: 1.82861,
    width: 7.31429,
    height: 18.2857,
    rx: 3.65714,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_2021_276"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.4639,
    width: 7.31429,
    height: 18.2857,
    rx: 3.65714,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInspire);
export default __webpack_public_path__ + "static/media/iconInspire.8ac47e886e9a08e9311f598a5bf987c0.svg";
export { ForwardRef as ReactComponent };